import type {
  Article,
  ArticleMeta,
  Book,
  BookTree,
  Chapter,
  ChapterWithArticles,
} from "@/types/api";
import { request } from "./transport";

export type { ArticleMeta, BookTree, ChapterWithArticles };
export type Locale = "en" | "zh";

function localeQuery(locale?: Locale): string {
  return locale ? `?locale=${locale}` : "";
}

export const library = {
  listBooks: (locale?: Locale) =>
    request<{ books: Book[] }>(`/books${localeQuery(locale)}`),

  getBook: (idOrSlug: string, locale?: Locale) =>
    request<{ book: Book }>(`/books/${idOrSlug}${localeQuery(locale)}`),

  // One-shot reader payload — book + chapters + article metadata (no
  // body_md). Bodies fetched on demand via getArticle.
  getBookTree: (idOrSlug: string, locale?: Locale) =>
    request<BookTree>(`/books/${idOrSlug}/tree${localeQuery(locale)}`),

  // Per-chapter listing — used by SaveToLibraryForm's chapter picker.
  // The reader page uses getBookTree instead.
  listChapters: (bookIdOrSlug: string, locale?: Locale) =>
    request<{ chapters: Chapter[] }>(
      `/books/${bookIdOrSlug}/chapters${localeQuery(locale)}`,
    ),

  getArticle: (idOrSlug: string, locale?: Locale) =>
    request<{ article: Article }>(
      `/articles/${idOrSlug}${localeQuery(locale)}`,
    ),
};
